<!-- <div> -->

    <!-- <p-tabView> -->
        
        <!-- Tab For Submited Bills -->
        <!-- <p-tabPanel header="Bill Submissions" >  -->
<div class="flex grid m-3">
    <div class="col-3">
        <p-card header="Bill Submissions" class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full">
            <p-dataView [value]="(submittedBills$ | async) || []" emptyMessage="No Bills Submitted For Processing">
                <ng-template pTemplate="footer">
                    <!-- allow drag and drop uploader here -->
                        <p-fileUpload
                        #fileUpload
                        multiple
                        maxFileSize="10000000" 
                        customUpload
                        accept=".pdf"
                        (uploadHandler)="uploadFiles($event, fileUpload)",
                        [auto]="true">
                        <ng-template pTemplate="empty">
                            <div class="flex align-items-center justify-content-center flex-column">
                                <i class="pi pi-cloud-upload border-2 border-circle p-3 text-xl text-400 border-400"></i>
                                <p class="mt-2 mb-0">Drag and drop files here to upload.</p>
                            </div>
                        </ng-template>
                        </p-fileUpload>
                </ng-template>

                <ng-template pTemplate="list" let-bills>
                    <div *ngFor="let bill of bills; let first = first">
                        <!-- <hr *ngIf="!first"> -->
                        <lib-draft-medical-bill [medicalBillSubmission]="bill"></lib-draft-medical-bill>
                    </div>
                </ng-template>
            </p-dataView>
        </p-card>
    </div>
    <div class="col-3">
        <p-card header="Processed Submissions" class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full">
            <p-dataView [rows]="5" [paginator]="true" [value]="(unconfirmedSubmissions$ | async) || []" emptyMessage="No Bills Awaiting Confirmation">
                
                <ng-template pTemplate="list" let-bills>
                    <div *ngFor="let bill of bills; let first = first">
                        <!-- <hr *ngIf="!first"> -->
                        <lib-draft-medical-bill  [medicalBillSubmission]="bill.billSubmission" [draftMedicalBill]="bill" ></lib-draft-medical-bill>
                    </div>
                </ng-template>
            </p-dataView>
        </p-card>
    </div>
    <div class="col-3">
        <p-card header="Reviewed Medical Bills" class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full">
            <p-dataView class="flex h-full"  [rows]="5" [paginator]="true" [value]="(confirmedBills$ | async) || []" emptyMessage="No Confirmed Bills">
                <ng-template pTemplate="list" let-bills>
                    <div  *ngFor="let bill of bills; let first=first">

                        <!-- <hr *ngIf="!first"> -->
                        <lib-medical-bill [medicalBill]="bill" >

                        </lib-medical-bill>
                    </div>
                </ng-template>
            </p-dataView>
        </p-card>
    </div>
    <div class="col-3">
        <p-card header="Ready For Submission" class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full" >
            <p-dataView class="flex h-full"  [rows]="10" [paginator]="true" [value]="(lockedBills$ | async) || []" emptyMessage="No Locked Bills">
                <ng-template pTemplate="list" let-bills>
                    <div  *ngFor="let bill of bills; let first=first">

                        <!-- <hr *ngIf="!first"> -->
                        <lib-locked-repriced-bill [repricedBill]="bill">

                        </lib-locked-repriced-bill>
                    </div>
                </ng-template>
            </p-dataView>
        </p-card>
    </div>
</div>
        <!-- </p-tabPanel> -->


        <!-- Tab For Uploaded Draft Bills, waiting for perfection and then adjustment-->
        <!-- <p-tabPanel header="Uploaded Medical Bills"> -->

        <!-- </p-tabPanel> -->
        
         <!-- Bills Ready For Markup -->

         <!-- Bills Ready for Submission To Payer -->

         <!-- Dispositions Returned from Payer -->
    <!-- </p-tabView> -->


<!-- </div> -->

